import { createSelector } from "@reduxjs/toolkit";

export const leadsListState = (state) => state.leadsList;

export const leadsListSelectors = createSelector(leadsListState, (state) => state);
